export const getQueryErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === 'object') {
    const responseError = (error as { response?: { data?: { error?: unknown } } }).response?.data?.error;
    if (typeof responseError === 'string' && responseError.trim().length > 0) {
      return responseError;
    }

    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim().length > 0) {
      return message;
    }
  }

  return fallback;
};
